import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-time",
  "use": "icon-time-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-time\"><path d=\"M520 559h204c17.673 0 32 14.327 32 32s-14.327 32-32 32H488c-17.673 0-32-14.327-32-32q0-.25.004-.5L456 590V277c0-17.673 14.327-32 32-32s32 14.327 32 32zm-8 401C264.576 960 64 759.424 64 512S264.576 64 512 64s448 200.576 448 448-200.576 448-448 448m0-64c212.077 0 384-171.923 384-384S724.077 128 512 128 128 299.923 128 512s171.923 384 384 384\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol